import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_LINKS } from '@/api/endpoints';
import { LINKS_QUERY_KEY } from '@/api/queryKeys';
import type { LinksResponse } from '@/types/links';
import { unwrapAxiosResponse } from '@/utils/axios';

export const useLinks = () =>
  useQuery<LinksResponse>({
    queryKey: LINKS_QUERY_KEY,
    queryFn: () =>
      apiClient.get<LinksResponse>(API_LINKS).then(unwrapAxiosResponse),
  });
